import getField from '@form/formGenerator'

export const userSaveUrl = `${import.meta.env.VITE_API_URL}/api/users/update`

export const userInfosFormObject = {
  id: null,
  email: null,
  fullName: null,
  cellPhone: null,
  homePhone: null,
  address: null,
  zipCode: null,
  city: null,
  jobTitle: null
}

export const userInfosFormFields = (
  userFormObject,
  updateFormObject,
  updateFormObjectProp,
  saveForm,
  errors,
  isLoading,
  t,
  data,
  creationModalCaller
) => {
  const fields = [
    {
      type: 'text',
      name: 'jobTitle',
      label: t('labels.job_title'),
      value: userFormObject.jobTitle,
      key: 'userFormObject-jobTitle',
      cssClass: 'column is-6'
    }, {
      type: 'text',
      name: 'fullName',
      label: t('labels.full_name'),
      value: userFormObject.fullName,
      key: 'userFormObject-fullName',
      cssClass: 'column is-6'
    },
    {
      type: 'email',
      name: 'email',
      label: t('labels.email'),
      value: userFormObject.email,
      key: 'userFormObject-email',
      cssClass: 'column is-6'
    },
    {
      type: 'text',
      name: 'cellPhone',
      label: t('labels.cell_phone'),
      value: userFormObject.cellPhone,
      key: 'userFormObject-cellPhone',
      cssClass: 'column is-6'
    },
    {
      type: 'text',
      name: 'homePhone',
      label: t('labels.home_phone'),
      value: userFormObject.homePhone,
      key: 'userFormObject-homePhone',
      cssClass: 'column is-6'
    },
    {
      type: 'text',
      name: 'address',
      label: t('labels.address'),
      value: userFormObject.address,
      key: 'userFormObject-address',
      cssClass: 'column is-6'
    },
    {
      type: 'number',
      name: 'zipCode',
      label: t('labels.zip_code'),
      value: userFormObject.zipCode,
      key: 'userFormObject-zipCode',
      cssClass: 'column is-6'
    },
    {
      type: 'select',
      name: 'city',
      label: t('labels.city'),
      value: null !== userFormObject.city ? userFormObject.city.id : userFormObject.city,
      key: 'missionMairieFormObject-city',
      cssClass: 'mission-city column is-6',
      withIcon: false,
      help: t('help.city_help'),
      canCreate: true,
      creationModalCaller: () => creationModalCaller('city', 'cities'),
      options: data.cities,
      disabled: false,
      error: [],
      required: true
    },
    'ROLE_PILOT' === userFormObject.roles && {
      type: 'file',
      name: 'avatar',
      blobPoster: userFormObject.avatar ?? false,
      cssClass: 'column is-6 user-avatar',
      simpleInput: false,
      key: 'userFormObject-user-avatar',
      disabled: false,
      label: t('labels.user_avatar'),
      targetUrl: `${import.meta.env.VITE_API_URL}/api/push/temp-files`,
      isRequired: true
    },
    {
      type: 'button',
      buttons: true,
      callback: saveForm,
      cancel: false,
      validateText: t('actions.save'),
      cssClassParent: 'column is-12',
      cssClassValidate: 'button is-blue',
      validateIcon: 'icon-done',
      key: 'userFormObject-form',
      isLoading
    },
    {
      type: 'hidden',
      name: 'id',
      value: parseInt(userFormObject.id),
      key: 'userFormObject-id'
    }
  ]
  return fields.map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject, updateFormObjectProp)
  })
}